import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { createSlug } from './SoundPage';
import { HeartIcon, PlayIcon, PauseIcon, SpinnerIcon, DownloadIcon } from './Icons';
import './SoundBand.css';

const SoundBand = ({ sound, isFavorite, onToggleFavorite, isPlaying, onPlay }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const downloadRef = useRef();

  // Close menu on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (downloadRef.current && !downloadRef.current.contains(e.target)) {
        setShowDownload(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);



  const handlePlayPause = (e) => {
    e.stopPropagation(); // Stop the event from bubbling up and causing chaos
    if (!isLoading) {
      onPlay();
    }
  };


  return (
    <div className="sound-band">
      <div className="play-section">
        <button className={`play-btn ${isLoading ? 'loading' : ''}`} onClick={handlePlayPause} disabled={isLoading}>
          {isLoading ? <SpinnerIcon /> : isPlaying ? <PauseIcon /> : <PlayIcon />}
        </button>
        <div className={`sound-visualizer ${isPlaying ? 'active' : ''}`}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>

      <div className="band-info">
        <Link to={`/sons/${createSlug(sound.title)}`} className="band-title-link">
          <h3 className="band-title">{sound.title}</h3>
        </Link>
        <p className="band-author">par {sound.author}</p>
      </div>

      {/* Progress bar is disabled as playback is now global */}
      <div className="progress-bar-container-disabled">
        <div className="progress-fill-disabled" />
      </div>

      <div className="band-tags">
        {sound.tags.slice(0, 2).map(tag => <span key={tag} className="tag">#{tag}</span>)}
      </div>

      <span className="band-duration">{sound.duration}</span>

      <button className={`favorite-btn ${isFavorite ? 'active' : ''}`} onClick={onToggleFavorite} title="Favori">
        <HeartIcon filled={isFavorite} />
      </button>

      <div className="download-wrapper" ref={downloadRef}>
        <button className="download-btn" onClick={() => setShowDownload(prev => !prev)} title="Télécharger">
          <DownloadIcon />
        </button>
        {showDownload && (
          <div className="download-options">
            <a href={sound.downloadUrl} target="_blank" rel="noopener noreferrer">MP3</a>
            {sound.wavUrl && (
              <a href={sound.wavUrl} target="_blank" rel="noopener noreferrer">WAV</a>
            )}
          </div>
        )}
      </div>

    </div>
  );
};

export default SoundBand;
